import React, {useEffect, useState, useTransition} from 'react';
import {InternalPageRoot, ThemedButton, ThemedDropdownMenu, ThemedIconButton, ThemedInput} from "../index";
import {useTheme} from "../../common/ProjectThemeProvider";
import {
    checkNullArr,
    checkNullStr,
    copyTextToClipboard,
    createTimeout,
    getJsonValue,
    getDefStr,
    getFutureDate,
    getJsonValueFromNestedKeys,
    getUrlMainDomain,
    isBoolTrue,
    isJsonValueTrue,
    parseInteger
} from "../../common/fusion-ui/utils/ReactUtils";
import {formatDateValue, printError, printLog, sendRequest} from "../utils/AppUtils";
import {useToast} from "../../common/fusion-ui/provider/ToastProvider";
import {Keys, ModuleFieldsData, Modules, ReqUrls, ShowViewType} from "../config/AppConfig";
import {CssVariant, DurationUnits, IconClass, Patterns} from '../../common/fusion-ui/config/FusionConfig';
import {useConfig} from "../context/ConfigProvider";
import {AutoCompleteView, ExpView, Flexbox, GridBox, Image, IMsgButton, Label, NullMsgLabel} from "../../common/fusion-ui";
import {useLocation} from "react-router-dom";
import {IsProd} from "../../common/CommonConfig";
//https://dribbble.com/shots/23186203-Share-Project-Pop-Up
//https://dribbble.com/shots/20207179-Share-modal

/**
 * Create share-page link panel/dialog/drawer component.
 *
 * @example
 * const [openShareDialog, setOpenShareDialog] = useState(false);
 * <PageLinkSharePanel
 *     customShareUrl={shareUrl} //optional
 *     open={openShareDialog}
 *     onSuccess={() =>{}};
 *     onHide={() => setOpenShareDialog(false)};
 *     onSuccessAndHide={() => setOpenShareDialog(false)};
 * />
 */
const PageLinkSharePanel = React.memo(({
                                           // tag,
                                           // module,
                                           customShareUrl,
                                           open,
                                           onHide,
                                           onSuccess,
                                           onSuccessAndHide,
                                           // showAs = ShowViewType.DRAWER,
                                           showAs = ShowViewType.DIALOG,
                                       }) => {
    const TAG = "PageLinkSharePanel";
//https://my.stripo.email/editor/v1/1277555/email/7531488
    const location = useLocation();

    const theme = useTheme();
    const {showToast, changeToastVariant} = useToast();
    const {isConfigTrue, getConfig, updateConfig} = useConfig();

    const moduleName = Modules.LoginBypass;
    const mf = ModuleFieldsData[Modules.LoginBypass];

    const EMAIL_TEMPLATES_DUMMY = [
        'https://cdn.pixabay.com/photo/2019/06/19/07/13/email-4284157_1280.png',
        'https://cdn.pixabay.com/photo/2014/02/13/07/28/wordpress-265132_1280.jpg',
        'https://cdn.pixabay.com/photo/2017/12/02/14/38/contact-us-2993000_1280.jpg',
        'https://cdn.pixabay.com/photo/2024/01/25/21/36/greeting-card-8532714_1280.jpg',
        'https://cdn.pixabay.com/photo/2024/03/26/11/57/network-8656639_1280.jpg',
        'https://cdn.pixabay.com/photo/2017/11/17/09/37/finger-2956974_1280.jpg',
        'https://cdn.pixabay.com/photo/2017/02/08/08/38/mail-2048128_1280.png',
        'https://cdn.pixabay.com/photo/2016/01/10/22/52/letters-1132703_1280.png',
        'https://cdn.pixabay.com/photo/2018/03/17/10/51/post-it-notes-3233653_1280.jpg',
        'https://cdn.pixabay.com/photo/2017/01/12/15/53/email-1975010_1280.png',
        'https://cdn.dribbble.com/userupload/11909115/file/original-4607a443d70cb10fa0941ceecaa4c666.png?resize=752x',
        'https://cdn.dribbble.com/userupload/3060866/file/original-bd4118d51bfd16327ff7e96e6eb292c0.png?resize=752x',
        'https://cdn.pixabay.com/photo/2016/11/03/11/57/accountant-1794122_1280.png',
        'https://cdn.pixabay.com/photo/2024/04/14/23/25/ai-generated-8696431_1280.png',
        'https://cdn.pixabay.com/photo/2016/11/29/06/15/plans-1867745_1280.jpg',
        'https://cdn.pixabay.com/photo/2015/09/20/15/46/binding-contract-948442_1280.jpg',
        'https://cdn.pixabay.com/photo/2016/09/14/08/18/film-1668918_1280.jpg',
        'https://cdn.pixabay.com/photo/2014/11/18/11/06/paper-535969_1280.jpg',
        'https://cdn.pixabay.com/photo/2024/05/18/12/46/top-down-view-8770296_1280.jpg',
        'https://cdn.pixabay.com/photo/2017/12/22/08/01/school-supplies-3033204_1280.jpg',
        'https://cdn.pixabay.com/photo/2024/01/05/16/33/bauhaus-art-8489770_1280.png',
        'https://cdn.pixabay.com/photo/2016/09/08/04/12/programmer-1653351_1280.png',
    ]

    const NAME_KEY = 'name';
    const VIEW_HEIGHT = '32px';
    const EXP_DATE_FORMAT = 'YYYY-MM-DD HH:mm:ss';

    const Fields = {
        isDataLoading: 'isDataLoading',
        isDataFound: 'isDataFound',
        dataLoadingMsg: 'dataLoadingMsg',
        isDataFetched: 'isDataFetched',

        isMemberListLoading: 'isMemberListLoading',
        isMemberListFound: 'isMemberListFound',
        memberListLoadingMsg: 'memberListLoadingMsg',
        isMemberListFetched: 'isMemberListFetched',

        panelMsg: 'panelMsg',
        panelMsgColor: 'panelMsgColor',

        submitBtn_AsLoading: 'submitBtn_AsLoading',
        submitBtn_disabled: 'submitBtn_disabled',
        copyLink_AsLoading: 'copyLink_AsLoading',
        copyLink_disabled: 'copyLink_disabled',
        copyLinkFetched: 'copyLinkFetched',

        //form
        guestUserShareLink: 'guestUserShareLink',
        membersSelectOnly: 'membersSelectOnly',
        linkExpireInputValue: 'linkExpireInputValue',
        linkExpireDropdownOption: 'linkExpireDropdownOption',
        linkExpireDropdownOptionRepr: 'linkExpireDropdownOptionRepr',
        useLimitInputValue: 'useLimitInputValue',

        showPopup: 'showPopup',

        templateViewExpanded: 'templateViewExpanded',
        emailTemplate_selectedIndex: 'emailTemplate_selectedIndex',
    };
    const [fieldsData, setFieldsData] = useState({
        // [Fields.isDataLoading]: true,//ISSUE: Keeps the panel loading
    });
    const [formData, setFormData] = useState({});
    const [memberList, setMemberList] = useState([]);
    const [emailTemplates, setEmailTemplates] = useState(EMAIL_TEMPLATES_DUMMY);

    const [copyShareLinkPending, startCopyShareLinkTransition] = useTransition();

    useEffect(() => {
        if (isBoolTrue(open)) {
            Promise.all([fetchMemberList(), fetchGuestUserShareLink(true, false)]);
            // fetchMemberList();
            if (!checkNullStr(getField(Fields.isDataLoading))) {
                updateField(Fields.isDataFetched, true);
                updateField(Fields.isDataFound, true);
                updateField(Fields.isDataLoading, false);
                updateField(Fields.dataLoadingMsg, '');
                updateField(Fields.linkExpireDropdownOption, DurationUnits.dy.unit);
                updateField(Fields.linkExpireDropdownOptionRepr, DurationUnits.dy.repr);
                updateField(Fields.emailTemplate_selectedIndex, 0);
            }
        }
    }, [open]);

    useEffect(() => {
    }, []);

    return (<>
        <InternalPageRoot
            tag={showAs == ShowViewType.PAGE ? TAG : getConfig(Keys.tracker_currPageTag)}
            moduleName={showAs == ShowViewType.PAGE ? moduleName : getConfig(Keys.tracker_currPageModule)}
            // title={`Share URL`}
            title={<span className={'fw-semi-bold fs-normal text-wrap select-none'}>
                <span>Share URL</span>
                <span>&nbsp;&apos;<span className={'highlight-primary-hover transition-sm'}
                                   onClick={() => {
                                       copyTextToClipboard(getBrowserUrl());
                                       toast('URL copied to clipboard', CssVariant.info);
                                   }}>
                    {getBrowserUrl()}
                </span>&apos;&nbsp;</span>

                {!IsProd && <span>
                     <ThemedIconButton
                         className={'p-2 fs-normal'}
                         mx={2}
                         outlined={true}
                         borderWidth={0}
                         variant={theme.primaryBlue}
                         icon={IconClass.refresh}
                         tooltip={"Refresh"}
                         onClick={() => {
                             fetchGuestUserShareLink(false, false);
                             // Promise.all([fetchMemberList(), fetchGuestUserShareLink(true, false)]);
                         }}
                     />
                </span>}
            </span>}
            isDataFound={getField(Fields.isDataFound)}
            isDataLoading={getField(Fields.isDataLoading)}
            dataLoadingMsg={getField(Fields.dataLoadingMsg)}
            showHeader={false}
            closeOnEscape={true}
            closeOnOutsideClick={false}
            dialogMd={7}
            open={isBoolTrue(open) || isFieldTrue(Fields.showPopup)}
            onHide={handlePopupHide}
            showAs={showAs}
            popupProps={{
                titleAt: 'start',
                headerClassName: `${showAs == ShowViewType.DRAWER ? 'py-2 px-3' : 'pb-3'}`,
                titleClassName: `fs-lg fw-semi-bold px-2x mt-n1`,
                // contentClassName:'pb-3 mt-2 px-4',
                contentClassName: `pt-3 pb-0 ${showAs == ShowViewType.DRAWER ? 'mb-n3' : ''}`,
                headerStyle: {
                    backgroundColor: theme.text10
                }
            }}
        >
            {createPanel()}
        </InternalPageRoot>
    </>);

    function createPanel() {
        return <div className={'w-100'}>
            {/*header*/}
            {checkNullStr(getField(Fields.guestUserShareLink)) &&
                <div className={'mt-2'}>
                    {/*url*/}
                    <div className={`w-100 d-flex al-start jc-start-sm fd-row flex-wrap-sm ${isFieldTrue(Fields.copyLink_disabled) ? 'disable-item' : ''}`}
                    >
                        <Label className={'border-1 rounded-3 m-0 p-0 px-2 py-1 fw-semi-boldx cursor-text select-none'}
                               textAt={'start'} color={theme.text90} bgColor={theme.text05}
                               widthClass={'100'}
                               style={{borderColor: theme.text10}}>
                            {getField(Fields.guestUserShareLink)}
                        </Label>

                        {/*copy-button*/}
                        <Flexbox alignAt={'center'}>
                            <ThemedIconButton
                                className={'p-1 rounded-2'}
                                ml={3}
                                mx={2}
                                size={'31px'}
                                outlined={true}
                                variant={theme.primaryBlue}
                                disableVariant={'xl'}
                                icon={IconClass.copy}
                                tooltip={"Copy Share-Link"}
                                circular={false}
                                loadingVariant={CssVariant.primary}
                                asLoading={copyShareLinkPending}
                                disabled={copyShareLinkPending}
                                onClick={() => {
                                    startCopyShareLinkTransition(() => {
                                        copyTextToClipboard(getField(Fields.guestUserShareLink));
                                        toast(`URL copied to clipboard`, CssVariant.info);
                                    });
                                }}
                            />

                            {createShareLinkWarningIMsgButton()}
                        </Flexbox>
                    </div>
                </div>}

            {/*body*/}
            <div className={'px-3x pb-2'}>
                {/*<div>record-title: {getConfig(Keys.sharePanel_recordTitle)}</div>*/}
                {/*<div>record-description: {getConfig(Keys.sharePanel_recordDescription)}</div>*/}

                {/*member-list*/}
                <div className={'mt-3'}>
                    <AutoCompleteView
                        tagStyle={{borderColor: theme.text}}
                        msgLabelColor={theme.text70}
                        nameColor={theme.text}
                        searchColor={theme.text}
                        dropdownItemHoverBg={theme.primaryBlue20}
                        dropdownItemHoverColor={theme.primaryBlueDark}
                        dropdownItemSelectedBg={theme.primaryBlue20}
                        dropdownItemSelectedColor={theme.primaryBlue}
                        tagBoxBorderColor={theme.text20}
                        labelColor={theme.text40}
                        countColor={theme.text40}
                        tagBg={theme.text10}
                        // dropdownHeight={'45vh'}
                        tagBoxMinHeight={'25vh'}
                        tagBoxHeight={'25vh'}
                        searchPlaceholder={'Search for members...'}
                        label={"Members"}
                        showLoading={isFieldTrue(Fields.isMemberListLoading)}
                        synced={true}
                        showRefresh={true}

                        options={getMemberList()}
                        itemNameKey={NAME_KEY}
                        itemImageKey={'image'}
                        itemHoverAltNameKey={'email'}

                        removeColor={theme.text}
                        refreshLoading={isFieldTrue(Fields.isMemberListLoading)}
                        disableRefresh={isFieldTrue(Fields.isMemberListLoading)}

                        onSelected={(updatedList, selectedList) => {
                            updateField(Fields.membersSelectOnly, selectedList);
                            // log('recList.userList.onUsersSelected.updatedList:', updatedList);
                            // log('AutoCompleteView.userList.onUsersSelected.selectedList:', selectedList);
                        }}
                        onRefresh={() => fetchMemberList(false)}
                        dropdownStyle={theme.autoCompleteDropdownStyles}
                    />
                </div>

                {/*options*/}
                <div className={'mt-3'}>
                    <GridBox className={`px-2`} md={6} gap={0} gapX={1}>
                        {/*expire input & dropdown*/}
                        <div className={''}>
                            <Label className={'text-input-label px-2 m-0 p-0 mb-1'} textAt={'start'} color={theme.text40}>
                                <span>Expire duration</span>
                                <span className={'ms-2'}>
                                         <IMsgButton
                                             tooltip={`The link expires after the specified duration. (Default is 24 hours).`}
                                             // tooltip={`The link will expire after the specified duration and will no longer be active. Default is 24 hours.`}
                                         />
                                    </span>
                            </Label>

                            <Flexbox className={'m-0 p-0 rounded-3 w-100'} position={'relative'} overflow={'hidden'}
                                     justifyAt={'start'} alignAt={'center'} borderVariant={1}
                                     style={{borderColor: theme.text20, width: 'auto'}}>
                                {/*expire-input*/}
                                <ThemedInput
                                    mainWrapperClassName={'w-100'}
                                    wrapperClassName={'m-0 p-0 w-100'}
                                    className={`border-none me-3 ${checkNullStr(getField(Fields.linkExpireInputValue)) ? 'pe-5' : ''}`}
                                    id={Fields.linkExpireInputValue}
                                    showMsg={false}
                                    type={'text'}
                                    showLabel={false}
                                    style={{height: '34px'}}
                                    placeholder={`Expire duration`}
                                    pattern={Patterns.plainNumber}
                                    validate={true}
                                    value={getField(Fields.linkExpireInputValue)}
                                    onChange={(e) => {
                                        let value = Number(e.target.value);
                                        const maxLimit = getJsonValue(Object.values(DurationUnits).find(item => item.unit == getField(Fields.linkExpireDropdownOption)), 'max');
                                        // log('linkExpireInputValue.onChange.value:', value, 'maxLimit:', maxLimit);
                                        if (checkNullStr(value) && !Number.isNaN(value)) {
                                            if (value == 0) {
                                                updateField(Fields.linkExpireInputValue, '');
                                                return;
                                            }
                                            if (checkNullStr(maxLimit)) {
                                                if (value <= maxLimit) {
                                                    updateField(Fields.linkExpireInputValue, value);
                                                } else {
                                                    toast(`Max '${getField(Fields.linkExpireDropdownOption)}' limit: ${maxLimit}`, CssVariant.warning);
                                                }
                                            } else if (!checkNullStr(maxLimit)) {
                                                updateField(Fields.linkExpireInputValue, value);
                                            }
                                        } else {
                                            toast('Invalid duration!', CssVariant.warning);
                                        }
                                    }}/>
                                {/*expire-dropdown*/}
                                <ThemedDropdownMenu
                                    className={'ms-n2x'}
                                    buttonClassName={'border-none fw-semi-bold'}
                                    roundedVariant={0}
                                    outlined={false}
                                    buttonHeight={'34px'}
                                    defOption={getField(Fields.linkExpireDropdownOption)}
                                    onExpand={(opened) => {
                                        updateField(Fields.isTypeDropdownOpened, isBoolTrue(opened));
                                    }}
                                    dropdownStyle={theme.autoCompleteDropdownStyles}
                                    onItemClick={(name, index, item) => {
                                        updateField(Fields.linkExpireDropdownOption, name);
                                        updateField(Fields.linkExpireDropdownOptionRepr, getJsonValue(item, 'repr'));

                                        //Update expire-value if it exceeds the max-value
                                        const maxLimit = getJsonValue(Object.values(DurationUnits).find(fItem => fItem.unit == name), 'max');
                                        if (parseInteger(getField(Fields.linkExpireInputValue)) > maxLimit) {
                                            toast(`Max '${getField(Fields.linkExpireDropdownOption)}' limit: ${maxLimit}`, CssVariant.warning);
                                            updateField(Fields.linkExpireInputValue, maxLimit);
                                        }
                                        // log('linkExpireDropdownOption.ThemedDropdownMenu.onItemClick.maxLimit:', maxLimit);
                                    }}>
                                    {/*{Object.values(DurationUnits).map(item => item.unit)}*/}
                                    {Object.values(DurationUnits).map(item => {
                                        return {
                                            id: item.unit,
                                            name: item.unit,
                                            repr: item.repr,
                                        }
                                    })}
                                </ThemedDropdownMenu>
                            </Flexbox>

                            {/*expire-date label*/}
                            {checkNullStr(getField(Fields.linkExpireInputValue)) &&
                                <Label className={'fs-sm m-0 p-0 px-2 fw-semi-bold text-nowrap'} color={theme.text70} textAt={'start'}>
                                        <span>
                                            <span className={'fw-normal'}>Link will expire at: </span>
                                            <span>
                                                {formatDateValue(getFutureDate({
                                                    value: getField(Fields.linkExpireInputValue),
                                                    unit: getField(Fields.linkExpireDropdownOption),
                                                    format: '',
                                                }))}
                                            </span>
                                        </span>
                                </Label>}
                        </div>

                        {/*share-limit*/}
                        <div style={{marginTop: '.1rem'}}>
                            <ThemedInput
                                mainWrapperClassName={'w-100'}
                                wrapperClassName={'m-0 p-0 w-100'}
                                innerWrapperClassName={'m-0 p-0 w-100'}
                                labelClassName={'px-2'}
                                style={{height: '34px'}}
                                id={Fields.useLimitInputValue}
                                showMsg={false}
                                type={'text'}
                                label={'Use Limit'}
                                placeholder={`Enter use limit`}
                                iMsg={<div className={'text-start px-2 text-wrap'}>
                                    {/*<div>{`This limit will determine how many times the shared-link can be used. Default is unlimited.`}</div>*/}
                                    {/*<div className={'text-warning mt-2'}>{`NOTE: It won't be applicable for 'Copied Link'`}</div>*/}
                                    <span>{`Sets usage limit for the shared link (Default is unlimited).`}</span>
                                    <span className={'text-warning xmt-2'}> {`Not applicable for 'Copied Link'`}</span>
                                </div>}
                                pattern={Patterns.plainNumber}
                                validate={true}
                                value={getField(Fields.useLimitInputValue)}
                                onChange={(e) => {
                                    let value = Number(e.target.value);
                                    if (value == 0) {
                                        updateField(Fields.useLimitInputValue, '');
                                        return;
                                    }
                                    updateField(Fields.useLimitInputValue, value);
                                }}/>
                        </div>
                    </GridBox>
                </div>

                {/*advance-settings*/}
                <div className={'mt-3 d-none'}>
                    <div style={{color: theme.text}}>
                        <ExpView
                            title={"Email Templates"}
                            className={'section rounded-3 highlight-dark-high-hoverx border-2'}
                            headerClassName={'highlight-dark-high-hover transition-sm'}
                            titleClassName={'fw-semi-bold m-0 p-0 px-1 '}
                            wrapperClassName={''}
                            toggleClassName={''}
                            contentClassName={''}
                            headerToggle={true}
                            asCollapsible={false}
                            style={{
                                borderColor: isFieldTrue(Fields.templateViewExpanded) ? theme.primary10 : theme.primary05,
                            }}
                            headerStyle={{
                                backgroundColor: isFieldTrue(Fields.templateViewExpanded) ? theme.primary10 : theme.primary05,
                            }}
                            titleStyle={{
                                // color: theme.text
                            }}
                            toggleStyle={{
                                // color: theme.text,
                            }}
                            wrapperStyle={{}}
                            contentStyle={{}}
                            scrollVariant={"dark"}
                            headerHeight={"30px"}
                            expanded={isFieldTrue(Fields.templateViewExpanded)}
                            expandOnHover={false}
                            showExpandToggle={true}
                            onToggleClick={(collapsed) => {
                                log('ExpView.onToggleClick.collapsed:', collapsed);
                                updateField(Fields.templateViewExpanded, !isBoolTrue(collapsed));
                            }}
                            // collapseHeight ={ '0'}//auto
                            height={'auto'}
                            // endControls={}
                        >
                            {createEmailTemplatesSection()}
                        </ExpView>
                    </div>
                </div>
            </div>

            {/*footer*/}
            <div className={'my-3 position-sticky'} style={{bottom: '0', backgroundColor: theme.bg}}>
                <GridBox className={'px-1x'} md={[3, 9]} sm={[3, 9]} justifyAt={'between jc-start-sm jc-start-md'}>
                    {/*copy-link*/}
                    <div className={''}>
                        <Flexbox className={'mx-2'} alignAt={'center'}>
                            <ThemedButton
                                className={'text-nowrap fw-semi-bold'}
                                sleek={true}
                                icon={isFieldTrue(Fields.copyLink_AsLoading) ? '' : 'bi bi-link'}
                                text={'Copy Link'}
                                outlined={true}
                                variant={theme.primaryBlue}
                                bgColor={theme.primaryBlue20}
                                hoverBgColor={theme.primaryBlue80}
                                color={theme.primaryBlue}
                                hoverColor={theme.textWhite}
                                borderColor={theme.primaryBlue}
                                borderWidth={1}
                                mr={2}
                                disableVariant={'lg'}
                                asLoading={isFieldTrue(Fields.copyLink_AsLoading)}
                                disabled={isFieldTrue(Fields.copyLink_disabled)}
                                onClick={() => fetchGuestUserShareLink(false, true)}
                            />
                            {createShareLinkWarningIMsgButton()}
                        </Flexbox>
                    </div>

                    {/*cancel, submit*/}
                    <Flexbox alignAt={'center'} justifyAt={'end'} justifyAtSm={'start'}>
                        {/*cancel*/}
                        <ThemedButton
                            className={'text-nowrap'}
                            sleek={true}
                            text={'Cancel'}
                            variant={theme.text}
                            bgColor={theme.text10}
                            hoverBgColor={theme.text20}
                            color={theme.text}
                            hoverColor={theme.text}
                            rippleColor={theme.text30}
                            mx={2}
                            disabled={isFieldTrue(Fields.submitBtn_AsLoading)}
                            onClick={handlePopupHide}
                        />

                        {/*submit*/}
                        <ThemedButton
                            className={'text-nowrap fw-semi-bold'}
                            sleek={true}
                            icon={'bi bi-send'}
                            text={isFieldTrue(Fields.submitBtn_AsLoading) ? 'Sending link...' : 'Send Link'}
                            variant={theme.primaryBlue}
                            hoverBgColor={theme.primaryBlueDark}
                            mx={2}
                            asLoading={isFieldTrue(Fields.submitBtn_AsLoading)}
                            disabled={isFieldTrue(Fields.submitBtn_disabled)}
                            onClick={handleSubmit}
                        />
                    </Flexbox>
                </GridBox>
            </div>
        </div>
    }

    function createShareLinkWarningIMsgButton() {
        return <div className={''}>
            <IMsgButton tooltip={
                <div className={'text-start'}>
                    <div>
                        <span>
                            <span className={'text-warning'}>{'Warning: '}</span>
                            {/*<span>{`This link will be viewed as 'Guest-User' (for members and non-members alike), and is valid for unlimited clicks.`}</span>*/}
                            {/*<span>{`This will be a generic link for members and non-members alike, and is valid for unlimited clicks`}</span>*/}
                            <span>{`This link is viewed as 'Guest-User' and is valid for unlimited clicks. Default expiration is 1 year.`}</span>
                        </span>
                    </div>
                    <div>
                        <span>
                            {/*<span className={'text-warning'}>NOTE: </span>*/}
                            {/*<span>Use-limit is not applicable for this link, and default expire-duration is 1 year.</span>*/}
                            {/*<span>Default expire-duration is 1 year.</span>*/}
                        </span>
                    </div>
                </div>}
            />
        </div>
    }

    function createEmailTemplatesSection() {
        return <div className={''}>
            {checkNullArr(emailTemplates)
                ? <div>
                    {/*header*/}
                    <div>
                        <Label className={'fw-semi-bold m-0 p-0'} color={theme.text60}>
                            Select an email-body template
                        </Label>
                    </div>

                    {/*slider*/}
                    <Flexbox className={`scroller scroller-x-auto scroll-dark pb-1 select-none`} justifyAt={'start'} alignAt={'start'}>
                        {emailTemplates.map((item, index) => {
                            return <div key={index + 'asdfdr'} className={`${index > 0 ? 'ps-3' : ''}`}>
                                <div className={``}>
                                    <Image
                                        className={`cursor-pointer border-2x border-solid transition rounded-3 border-primary-hover ${getField(Fields.emailTemplate_selectedIndex) == index ? `border-primary-light` : `border-t`}`}
                                        src={item}
                                        width={'120px'}
                                        height={'70px'}
                                        disableDrag={true}
                                        style={{borderWidth: '4px'}}
                                        onClick={() => {
                                            updateField(Fields.emailTemplate_selectedIndex, index);
                                        }}
                                    />
                                </div>
                            </div>
                        })}
                    </Flexbox>

                    {/*template-preview*/}
                    <div className={'my-2 mt-3'}>
                        <div className={`w-100`}>
                            <Image
                                wrapperClassName={``}
                                className={'rounded-3'}
                                src={emailTemplates[getField(Fields.emailTemplate_selectedIndex)]}
                                width={'100%'}
                                height={'260px'}
                                disableDrag={true}
                            />
                        </div>
                    </div>
                </div>
                : <NullMsgLabel color={theme.text}>No email templates found!</NullMsgLabel>}
        </div>
    }

    async function fetchMemberList(checkBefore = true) {
        const fun = 'fetchMemberList:';
        // log(fun, 'function-called!');
        if (!checkBefore || (checkBefore && !isFieldTrue(Fields.isMemberListFetched)) && !checkNullArr(memberList)) {
            updateField(Fields.isMemberListFetched, true);
            setMemberList([]);
            updateField(Fields.membersSelectOnly, []);
            updateField(Fields.isMemberListFound, false);
            updateField(Fields.isMemberListLoading, true);
            updateField(Fields.memberListLoadingMsg, "");
            updateField(Fields.panelMsg, "");

            const REQUEST_OPTIONS = {};
            try {
                sendRequest({
                    reqUrl: ReqUrls.fetchCompanyMembersList,
                    reqOptions: REQUEST_OPTIONS,
                    onFetched: ((fetchedData) => {
                        log(fun, 'fetchedData:', fetchedData);

                        let members = getJsonValueFromNestedKeys(fetchedData, ['data', 'members'], []);
                        const success = isJsonValueTrue(fetchedData, 'success');
                        const message = getJsonValue(fetchedData, 'message');

                        if (success) {
                            // toast(message, CssVariant.success);
                            updateField(Fields.memberListLoadingMsg, message);

                            //for testing only
                            // if (checkNullArr(members) && !IsProd) {
                            //     members = members.map((item) => {
                            //         return {
                            //             ...item,
                            //             selected: (getJsonValue(item, 'name') + '').toLowerCase().includes('test') || (getJsonValue(item, 'name') + '').toLowerCase().includes('guest')
                            //         }
                            //     });
                            //     updateField(Fields.membersSelectOnly, members.filter(member => isJsonValueTrue(member, 'selected')));
                            // }
                            setMemberList(members);
                            // panelLog(message);
                            // createTimeout(() => panelLog(''), 4000);
                        } else {
                            performFailureTasks(null, message);
                        }
                        updateField(Fields.isMemberListFound, success);
                        updateField(Fields.isMemberListLoading, false);
                    }),
                    onError: ((error) => {
                        performFailureTasks(error, error.message)
                    }),
                });
            } catch (error) {
                performFailureTasks(error, error.message)
            }
        }

        function performFailureTasks(error, message = "Couldn't load members, please refresh again!") {
            panelLogErr(message);
            toast(message, CssVariant.danger)
            if (error) logErr(fun, error);
            updateField(Fields.memberListLoadingMsg, message);
            updateField(Fields.isMemberListFound, false);
            updateField(Fields.isMemberListLoading, false);
            createTimeout(() => panelLog(''), 4000);
        }
    }

    function handleSubmit() {
        const fun = 'handleSubmit:';
        try {
            const dataToSend = getDataToSend();
            log(fun, 'dataToSend:', dataToSend);

            let allFieldsChecked = checkAllRequiredFields();
            // allFieldsChecked = false;//for checking
            if (allFieldsChecked) {
                updateField(Fields.submitBtn_AsLoading, true);
                updateField(Fields.submitBtn_disabled, true);

                const REQUEST_OPTIONS = {
                    formData: dataToSend,
                };
                sendRequest({
                    reqUrl: ReqUrls.loginBypass_insertSharePageLinks,
                    reqOptions: REQUEST_OPTIONS,
                    onFetched: ((fetchedData) => {
                        log(fun, 'fetchedData:', fetchedData);

                        const message = getJsonValue(fetchedData, 'message');
                        const success = isJsonValueTrue(fetchedData, 'success');

                        // updateField(Fields.submitBtn_disabled, false); //for testing only
                        if (success) {
                            toast(message, CssVariant.success);
                            if (showAs == ShowViewType.PAGE) {
                            } else {
                                createTimeout(() => {
                                    if (onSuccess) onSuccess();
                                    if (onSuccessAndHide) {
                                        handlePopupHide();
                                        onSuccessAndHide();
                                    }
                                }, 300);
                            }
                        } else {
                            performFailureTask(null, message);
                            updateField(Fields.submitBtn_disabled, false);
                        }
                        updateField(Fields.submitBtn_AsLoading, false);
                    }),
                    onError: ((error) => {
                        performFailureTask(error);
                    })
                });
            }
        } catch (error) {
            performFailureTask(error);
        }

        function performFailureTask(error, msg = "Share failed, please try again!") {
            if (checkNullStr(msg)) toast(msg, CssVariant.danger);
            updateField(Fields.submitBtn_AsLoading, false);
            updateField(Fields.submitBtn_disabled, false);
            if (error) logErr(fun, error);
        }
    }

    async function fetchGuestUserShareLink(checkBefore = true, copyLink = true) {
        const fun = 'fetchGuestUserShareLink:';
        if (!checkBefore || (checkBefore && !isFieldTrue(Fields.copyLinkFetched)) && !checkNullStr(getField(Fields.guestUserShareLink))) {
            updateField(Fields.copyLinkFetched, true);
            try {
                const dataToSend = getDataToSend();
                log(fun, 'dataToSend:', dataToSend);

                const proceed = true;
                // const proceed = false;//for checking
                if (proceed) {
                    updateField(Fields.copyLink_AsLoading, true);
                    updateField(Fields.copyLink_disabled, true);

                    const REQUEST_OPTIONS = {
                        generateNewLink: checkNullStr(getField(Fields.linkExpireInputValue)) && checkNullStr(getField(Fields.linkExpireDropdownOptionRepr)),
                        browserUrl: getUrlMainDomain(getBrowserUrl()),
                        formData: dataToSend,
                    };
                    sendRequest({
                        reqUrl: ReqUrls.loginBypass_guestUser_fetchShareLink,
                        reqOptions: REQUEST_OPTIONS,
                        onFetched: ((fetchedData) => {
                            log(fun, 'fetchedData:', fetchedData);

                            const tokenAlias = getJsonValueFromNestedKeys(fetchedData, ['data', 'tokenAlias'], '');
                            const shareLink = getJsonValueFromNestedKeys(fetchedData, ['data', 'shareLink'], '');
                            const message = getJsonValue(fetchedData, 'message');
                            const success = isJsonValueTrue(fetchedData, 'success');

                            updateField(Fields.copyLink_disabled, false);
                            updateField(Fields.copyLink_AsLoading, false);
                            log(fun, 'fetchedData.tokenAlias:', tokenAlias, 'shareLink:', shareLink);
                            if (success) {
                                if (checkNullStr(shareLink)) {
                                    updateField(Fields.guestUserShareLink, shareLink);

                                    if (copyLink) {
                                        copyTextToClipboard(shareLink);
                                        toast(`URL copied to clipboard`, CssVariant.info);
                                    } else {
                                        // toast(message, CssVariant.success);
                                    }
                                } else {
                                    toast("Share-Link not found, please try again!", CssVariant.danger);
                                }
                            } else {
                                toast(message, CssVariant.danger);
                            }
                        }),
                        onError: ((error) => {
                            toast(copyLink ? "Copy failed, please try again!" : "Couldn't generate share-link, please try again!", CssVariant.danger);
                            updateField(Fields.copyLink_AsLoading, false);
                            updateField(Fields.copyLink_disabled, false);
                            logErr(fun, error);
                        })
                    });
                }
            } catch (error) {
                toast(copyLink ? "Copy failed, please try again!" : "Couldn't generate share-link, please try again!", CssVariant.danger);
                updateField(Fields.copyLink_AsLoading, false);
                updateField(Fields.copyLink_disabled, false);
                logErr(fun, error);
            }
        }
    }

    function checkAllRequiredFields() {
        let checked = true;
        // if ()
        if (!checkNullArr(getField(Fields.membersSelectOnly))) {
            toast("Please select at least one member!", CssVariant.warning);
            checked = false;
        }
        return checked;
    }

    function getDataToSend() {
        return {
            shareLink: getField(Fields.guestUserShareLink),
            module: getConfig(Keys.tracker_currPageModule),
            [Keys.sharePanel_recordTitle]: getConfig(Keys.sharePanel_recordTitle),
            [Keys.sharePanel_recordDescription]: getConfig(Keys.sharePanel_recordDescription),
            [mf.redirectUrl.column]: getBrowserUrl(),
            [mf.shareLimit.column]: getField(Fields.useLimitInputValue, ''),
            [mf.expireAt.column]: getExpireDuration(),
            [mf.expireAt_JWT.column]: (checkNullStr(getField(Fields.linkExpireInputValue)) && checkNullStr(getField(Fields.linkExpireDropdownOptionRepr))) ? `${getField(Fields.linkExpireInputValue) + getField(Fields.linkExpireDropdownOptionRepr)}` : '',
            [mf.membersSelectOnly.column]: checkNullArr(getField(Fields.membersSelectOnly, []))
                ? getField(Fields.membersSelectOnly, []).map((item) => ({...item, image: ''})) : [],
        };
    }

    function getMemberList() {
        if (checkNullArr(memberList)) {
            return memberList;
        } else {
            return [];
        }
    }

    function getExpireDuration(dateFormat = EXP_DATE_FORMAT, toISO = true) {
        return (checkNullStr(getField(Fields.linkExpireInputValue)) && checkNullStr(getField(Fields.linkExpireDropdownOption)))
            ? getFutureDate({value: getField(Fields.linkExpireInputValue), unit: getField(Fields.linkExpireDropdownOption), format: dateFormat, toISO: toISO})
            : '';
    }

    function getBrowserUrl() {
        return getDefStr(customShareUrl, window.location.href) + '';
    }

    function handlePopupHide() {
        if (onHide) onHide();
        setFieldsData({});
        setFormData({});
    }

    function updateField(field, value) {
        setFieldsData(prevState => ({...prevState, [field]: value}));
    }

    function getField(field, defValue) {
        return getJsonValue(fieldsData, field, defValue);
    }

    function isFieldTrue(field) {
        return isBoolTrue(getField(field), true, true);
    }

    function updateFormField(clmField, value, direct = false) {
        setFormData(prevState => ({...prevState, [direct ? clmField : clmField.column]: value}));
    }

    function getFormField(clmField, defValue, direct = false) {
        return getJsonValue(formData, direct ? clmField : clmField.column, defValue);
    }

    function isFormFieldTrue(clmField, direct = false) {
        return isBoolTrue(getFormField(clmField, null, direct), true, true);
    }

    function toast(text, variant) {
        showToast(text + '');
        changeToastVariant(variant);
    }

    function panelLog(text) {
        updateField(Fields.panelMsg, text);
        updateField(Fields.panelMsgColor, theme.text90);
        log(...[text]);
    }

    function panelLogErr(...text) {
        updateField(Fields.panelMsg, text);
        updateField(Fields.panelMsgColor, 'red');
        log(...[text]);
    }

    function log(...text) {
        printLog(TAG, ...text);
    }

    function logErr(...text) {
        printError(TAG, ...text);
    }
});
export default PageLinkSharePanel;
